/** Destinazione post-login quando non c'è un return url valido da onorare. */
export const DEFAULT_POST_LOGIN_PATH = '/dashboard';

/** Landing di login: usarla come return url creerebbe un ciclo di redirect. */
const LOGIN_LANDING_PATH = '/home';

/**
 * Normalizza un return url proveniente dalla query string.
 *
 * Il valore è controllato da chi confeziona il link, quindi finisce nel
 * `redirectUri` passato a Keycloak: senza questo filtro sarebbe un open
 * redirect. Accettiamo solo path interni, escludendo le forme che i browser
 * risolvono verso un'altra origine (`//host`, `/\host`) e i caratteri di
 * controllo usati per spezzare l'URL.
 *
 * @returns il path ripulito, oppure `null` se non è utilizzabile.
 */
export function sanitizeReturnUrl(
  candidate: string | null | undefined,
): string | null {
  if (!candidate?.startsWith('/')) {
    return null;
  }

  if (candidate.startsWith('//') || candidate.startsWith('/\\')) {
    return null;
  }

  for (const char of candidate) {
    const code = char.charCodeAt(0);
    if (code <= 0x1f || code === 0x7f) {
      return null;
    }
  }

  if (
    candidate === LOGIN_LANDING_PATH ||
    candidate.startsWith(`${LOGIN_LANDING_PATH}?`)
  ) {
    return null;
  }

  return candidate;
}

/**
 * URL assoluto su cui Keycloak deve riportare l'utente dopo il login.
 *
 * È questo il canale che rende il magic link di firma resistente al giro di
 * autenticazione: il ritorno viaggia dentro l'URL OAuth, non in `localStorage`,
 * quindi sopravvive anche quando il link viene aperto dalla webview di un
 * client di posta e il login si completa in un browser che non ne condivide
 * lo storage.
 */
export function buildPostLoginRedirectUri(
  origin: string,
  returnUrl: string | null | undefined,
): string {
  return `${origin}${sanitizeReturnUrl(returnUrl) ?? DEFAULT_POST_LOGIN_PATH}`;
}
